import { AutogenModelReasonCode, AutogenRowReasonCode } from "./autogen/AutogenModelReasonCode";

export class ModelReasonCode extends AutogenModelReasonCode<RowReasonCode> {
    constructor() {
        super(RowReasonCode);
    }
}

export class RowReasonCode extends AutogenRowReasonCode {
}